import { createRoot } from '@wordpress/element';
import './scss/app.scss';
import ArchivingStatusBar from './views/ArchivingStatusBar';

const rootElement = document.getElementById('archive-status-notice');
const root = createRoot(rootElement);
root.render(<ArchivingStatusBar />);